import React, { Component } from 'react';

import Select from 'react-select';


import Grid from '@material-ui/core/Grid';
import { MAP_SELECTION_CONTAINER } from './../../../../constants/strings/StringsDashboard';

import { startMap, setData, setLayer, setPoint, deleteResize, insertPoints } from './mapScript';
// import { sendServiceAsync } from '../../../../Services/service';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as modalActs from './../../../../Actions/Modal';
import * as sessionActs from './../../../../Actions/Session'
import * as indexActs from './../../../../Actions/Dashboard'

import './mapStyle.css';


class MapSelection extends Component {
  state = {
    textValue: '',
    heatAdjustmentOpen: false,
    barrios: []
  }

  handleDateChange = (select) => {
    console.log(select)
    this.setState({ textValue: select.label })
    this.props.dashActions.selectFilter( { id: select.value, value: select.label }, 'barrio' );
  }

  componentDidMount() {
    let opts = {
      fromMap: this.props.fromMap,
      indexActions: this.props.dashActions,
      session: this.props.session,
      sendPolygon: this.props.sendPolygon,
      userCity: 'ASOMURA'
    }
    // sendServiceAsync('/api/v1/geo/getBarrios')
    //   .then(ans => ans.json())
    //   .then(res => this.setState({ barrios: res.response }))

    startMap(opts);
    setData(this.props.data);
  }

  componentDidUpdate(prevProps) {
    if (this.props.dashboard.signal && (prevProps.dashboard.signal !== this.props.dashboard.signal)) {
      this.props.dashActions.signalUpdate();
      setLayer();
    }
    if (this.props.dashboard.signalPoint && (prevProps.dashboard.signalPoint !== this.props.dashboard.signalPoint)) {
      this.props.dashActions.signalPoint();
      setPoint(this.props.dashboard.addPointGroup, this.props.dashActions.addedPoint);
    }
    if (JSON.stringify(this.props.dashboard.pointsToShow) !== JSON.stringify(prevProps.dashboard.pointsToShow)) {
      insertPoints(this.props.dashboard.pointsToShow);
    }

    if (prevProps.data !== this.props.data) {
      setData(this.props.data);
    }
    if (prevProps.currentShapes.comunes !== this.props.currentShapes.comunes) {
      let resp = [];
      this.props.currentShapes.comunes.map((val) => {
        let nombre = val.value.substring(0, val.value.length - 5);
        let data = this.props.dataList.comuna;
        for (let i = 0; i < data.length; i++) {
          if (data[i].value === nombre) {
            resp.push({ id: data[i].id, object: 'comuna_id', name: data[i].value });
          }
        }
        return null;
      });
      // selectComunas(resp);
    }
    if (prevProps.currentShapes.neigborhoods !== this.props.currentShapes.neigborhoods) {
      let resp = [];
      this.props.currentShapes.neigborhoods.map((val) => {
        let nombre = val.value.substring(0, val.value.length - 5);
        if (val.value.includes('(BA)')) {
          let data = this.props.dataList.barrio;
          for (let i = 0; i < data.length; i++) {
            if (data[i].value === nombre)
              resp.push({ id: data[i].id, object: 'barrio_id', name: data[i].value });
          }
        } else if (val.value.includes('(UR)')) {
          let data = this.props.dataList.urbanizacion;
          for (let i = 0; i < data.length; i++) {
            if (data[i].value === nombre)
              resp.push({ id: data[i].id, object: 'id', name: data[i].value });
          }
        }
        return null;
      });
      // selectBarrios(resp);
    }
  }

  componentWillUnmount() {
    deleteResize();
  }

  render() {
    setData(this.props.data);
    return (
      <Grid >
        <Grid container >
          <Grid item xs={12} className="client-label">
            {
              // !!this.state.barrios.length &&
              <Select
                className={''}
                options={this.state.barrios}
                onChange={this.handleDateChange}
                placeholder={MAP_SELECTION_CONTAINER.SEARCH_NEIGBORHOOD}
                value={this.state.textValue}
              />
            }
          </Grid>
        </Grid>
        <Grid container >
          <Grid item xs={12}  >
            <Grid id="map"></Grid>
          </Grid>
        </Grid>
      </Grid>

    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch),
    dashActions: bindActionCreators(indexActs, dispatch)
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    dashboard: state.dashboard,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapSelection);
